export default class HelloComponent {
    constructor() {
        // console.log("Hello from helloComponent.js");
    }
}
